import React from "react";

import { ArrowLeftIcon, SignOutIcon } from "@primer/octicons-react";
import { Link, useHistory, useLocation } from "react-router-dom";

import AuthService from "../../services/auth.service.ts";

import { BASENAME } from "../../services/constants";
import error_image from "./not_found_illustration.jpg";
import "./not-found.scss";

export default function NotFoundPage({ onLogout }) {
  const location = useLocation();
  const history = useHistory();

  const signOutAndRedirect = () => {
    AuthService.logout();

    if (typeof onLogout === "function") {
      onLogout();
    }

    history.push("/");
  };
  console.log(process.env.NEXT_PUBLIC_REDIRECT_URI);

  return (
    <main className="generic-not-found">
      <img
        src={error_image}
        alt="Page not found illustration"
        className="mb-3 d-block mx-auto"
      />

      <div>
        <h2 tabIndex="0" aria-label="Fehler 404, Etwas lief Schief">
          Oopsie! Irgendwas lief schief...
        </h2>
        <p tabIndex="0">
          Wir könnten leider die angeforderte Resource nicht laden. Hast du dich
          vielleicht vertippt?
        </p>
        <table className="table">
          <tbody>
            <tr>
              <th scope="row">Basename</th>
              <td>{"#" + BASENAME}</td>
            </tr>
            <tr>
              <th scope="row">Route</th>
              <td>{location.pathname}</td>
            </tr>
          </tbody>
        </table>
        <Link
          to="/"
          aria-label="Zurück zur Startseite"
          className="btn btn-primary px-5 mb-4 mr-3"
        >
          <ArrowLeftIcon className="mr-2" />
          Zurück zur Startseite
        </Link>{" "}
        <button
          role="link"
          className="btn btn-secondary px-5 mb-4"
          onClick={() => signOutAndRedirect()}
        >
          <SignOutIcon className="mr-2" />
          Benutzer wechseln
        </button>
      </div>
    </main>
  );
}
